import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-516acfd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProductsList" }
const _hoisted_2 = { class: "ProductsList__title" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "flex items-center justify-end mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "Сформированные товары (" + _toDisplayString(_ctx.products.length) + ")", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "ProductsList__item",
        key: `product-${i}`
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(product.title), 1),
        _createElementVNode("p", null, "Цена товара: " + _toDisplayString(product.price ? `${product.price} тенге` : 'Не указана'), 1),
        _createElementVNode("p", null, "Количество: " + _toDisplayString(product.count), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_the_button, {
            class: "red small text",
            disabled: _ctx.disabled,
            onClick: ($event: any) => (_ctx.emitRemove(i))
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Удалить товар ")
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ])
      ]))
    }), 128))
  ]))
}